import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface NoPriceTapEventProps {
  sourcePage: SourcePages;
}

export default function NoPriceTapEvent({ sourcePage }: NoPriceTapEventProps): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage === SourcePages.Srp ? SourcePages.SrpFilter : SourcePages.SeoSrpFilter,
    feature: Features.noPrice,
    engagement_type: 'hide_listings_no_price_tap',
  };
}
